/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import axiosInstance from "../utils/axiosInstance";

export function postRequeriment(data) {
  return axiosInstance
    .post("/requeriment/validar", data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((ex) => {
      throw ex;
    });
}
